<template>
    <v-list>
        <v-list-item>
            <SoliBtn
                block
                @click="$emit('input', false)"
                text="Find Available Class"
                color="soli-grey"
                outlined
            >
            </SoliBtn>
        </v-list-item>
        <v-list-item>
            <SoliBtn
                block
                @click="$emit('input', true)"
                text="Substitute for Private Lesson"
                color="soli-grey"
                outlined
            >
            </SoliBtn>
        </v-list-item>
    </v-list>
</template>

<script>
export default {};
</script>
